import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    borderBottom: "1px solid #dcdcdc",
    padding:'1%',
    borderRadius:'10px'
  },

  button: {
    width: '100%',
    display: "flex",
    marginLeft: "auto",
    alignItems: "left",
    justifyContent: "left",
    textAlign: "left",
  },

  title: {
    fontSize: "1.7em",
    color: "#000",
    fontWeight: "600",
    fontFamily: "Inter",
  },

  subTitle: {
    fontSize: "1.1em",
    color: "#8F9194",
    fontWeight: "400",
    fontFamily: "Inter",
    marginRight:"5%",
  },

  image: {
    width: "2em",
    paddingLeft: "0.5%",
  },
}));

export { useStyles };
